<div class="diagnostic-collection">
  <div class="diagnostic-collection__header">

  </div>
  <div class="diagnostic-collection__rows"> 
    <mat-table [dataSource]="diagnostics" [trackBy]="trackByDiagnostic" class="diagnostic-collection__table trg-table-2">
      <ng-container matColumnDef="timestamp">
        <mat-header-cell *matHeaderCellDef>Timestamp</mat-header-cell>
        <mat-cell *matCellDef="let d">
          <div>
            <span>{{d.timestampUtc | date:'short'}}</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="level">
        <mat-header-cell *matHeaderCellDef>Level</mat-header-cell>
        <mat-cell *matCellDef="let d">
          <div>
            <span>{{formatLevel(d)}}</span>
          </div>
        </mat-cell>
      </ng-container>
      
      <ng-container matColumnDef="message">
        <mat-header-cell *matHeaderCellDef>Message</mat-header-cell>
        <mat-cell *matCellDef="let d">
          <div class="text-ellipsis" [title]="formatMessage(d)">
            <span>{{formatMessage(d)}}</span>
          </div>
        </mat-cell>
      </ng-container>
      
      <ng-container matColumnDef="properties">
        <mat-header-cell *matHeaderCellDef>Properties</mat-header-cell>
        <mat-cell *matCellDef="let d">
          <div class="text-ellipsis" [title]="formatProperties(d)">
            <code>{{formatProperties(d)}}</code>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let d; columns: tableColumns" class="pointer {{formatLevelClass(d)}}" (click)="clickRow(d)"></mat-row>
    </mat-table>
  </div>
  <div class="diagnostic-collection__footer">

  </div>
</div>
